import { createSelector } from "reselect";

const usersSelector = state => state.adminReducer.users && state.adminReducer.users.users;

export const filterSelector = state => state.adminReducer.users && state.adminReducer.users.filter;


export const getFilteredUsersCollection = createSelector(
    usersSelector,
    filterSelector,
    (usersCollection, filter) => {
        console.log("Filter=" + filter);
        if (filter!==null && filter!=='') {

            let filtered = usersCollection.filter((user) => {

                let searchedString = "";

                if (typeof user.firstName !== 'undefined')
                    searchedString = searchedString + user.firstName.toLowerCase();
                if (typeof user.lastName !== 'undefined')
                    searchedString = searchedString + user.lastName.toLowerCase();
                if (typeof user.epicDisplayName !== 'undefined')
                    searchedString = searchedString + user.epicDisplayName.toLowerCase();

                return searchedString.indexOf(
                    filter.toLowerCase()) !== -1
            })

            return filtered;
        }
        return usersCollection;
    }


);